import { render, staticRenderFns } from "./BinMappings.vue?vue&type=template&id=5f98288f&scoped=true&"
import script from "./BinMappings.vue?vue&type=script&lang=js&"
export * from "./BinMappings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f98288f",
  null
  
)

export default component.exports